"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.PPDialog = void 0;
/*
* Componente de caixa de mensagem
*/
var react_1 = __importStar(require("react"));
//Componentes do Material Ui
var core_1 = require("@material-ui/core");
//Estilo do componente
var style_1 = require("./style");
require("../../assets/style.css");
var PPGrid_1 = require("../PPGrid/PPGrid");
/**
 * Componente de caixa de diálogo
 * @param {DialogInterface} props Propriedades
 */
var PPDialog = function (props) {
    var _a = (0, react_1.useState)(props.valueDialog ? props.valueDialog : false), open = _a[0], setOpen = _a[1];
    //Função para abrir o modal
    var openDialog = function () { setOpen(true); };
    //Função para fechar o modal
    var closeDialog = function () { setOpen(!open); };
    var classes = (0, style_1.useStyles)();
    /* tipo dos botões */
    var commandOption = function () {
        switch (props.command) {
            case "ok":
                return (react_1.default.createElement(core_1.Button, { className: classes.buttonOkAlone, id: props.id + '_' + 'button_ok', onClick: props.funcOk ? props.funcOk : props.closeDialog }, "OK"));
            case "ok_cancel":
                return (react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { className: classes.buttonOk, id: props.id + '_' + 'button_ok', onClick: props.funcOk ? props.funcOk : props.closeDialog }, "OK"),
                    react_1.default.createElement(core_1.Button, { className: classes.buttonCancelar, id: props.id + '_' + 'button_cancelar', onClick: props.funcCancel ? props.funcCancel : props.closeDialog }, "Cancelar")));
            case "yes_no":
                return (react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { className: classes.buttonSim, id: props.id + '_' + 'button_sim', onClick: props.funcYes ? props.funcYes : props.closeDialog }, "Sim"),
                    react_1.default.createElement(core_1.Button, { className: classes.buttonNão, id: props.id + '_' + 'button_nao', onClick: props.funcNo ? props.funcNo : props.closeDialog }, "N\u00E3o")));
            case "yes_no_cancel":
                return (react_1.default.createElement(core_1.Grid, { item: true },
                    react_1.default.createElement(core_1.Button, { className: classes.buttonSim, id: props.id + '_' + 'button_sim', onClick: props.funcYes ? props.funcYes : props.closeDialog }, "Sim"),
                    react_1.default.createElement(core_1.Button, { className: classes.buttonNão2, id: props.id + '_' + 'button_nao2', onClick: props.funcNo ? props.funcNo : props.closeDialog }, "N\u00E3o"),
                    react_1.default.createElement(core_1.Button, { className: classes.buttonCancelar, id: props.id + '_' + 'button_cancelar', onClick: props.funcCancel ? props.funcCancel : props.closeDialog }, "Cancelar")));
            default:
                return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    /* tipo do icone */
    var typeIcon = function () {
        if (props.icon) {
            switch (props.icon) {
                case "question":
                    return react_1.default.createElement("i", { className: "ppi ppi-question-mark-circle", id: "iconSizeMessageBox" });
                case "info":
                    return react_1.default.createElement("i", { className: "ppi ppi-information-circle", id: "iconSizeMessageBox" });
                case "warning":
                    return react_1.default.createElement("i", { className: "ppi ppi-exclamation", id: "iconSizeMessageBox" });
                case "error":
                    return react_1.default.createElement("i", { className: "ppi ppi-exclamation-circle", id: "iconSizeMessageBox" });
                default:
                    return react_1.default.createElement("i", { className: props.icon, id: "iconSizeMessageBox" });
            }
        }
        else {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
    };
    /* fundo escuro do modal */
    var typeBox = function () {
        switch (props.modal) {
            case true:
                return classes.backDrop2;
            case false:
                return classes.backDrop;
            default:
                return classes.backDrop2;
        }
    };
    function renderContents() {
        return (react_1.default.createElement(core_1.Grid, null,
            react_1.default.createElement(PPGrid_1.PPGrid, { contents: props.contents, cssClass: "default" })));
    }
    ;
    var functionModal = function () {
        return props.command
            ? react_1.default.createElement(core_1.Modal, { id: props.id, className: classes.messageBox, open: props.valueDialog ? props.valueDialog : open, onClose: props.closeDialog ? props.closeDialog : closeDialog, closeAfterTransition: true, BackdropComponent: core_1.Backdrop, BackdropProps: { timeout: 500, classes: { root: typeBox() } } },
                react_1.default.createElement(core_1.Fade, { in: props.valueDialog ? props.valueDialog : open },
                    react_1.default.createElement(core_1.Grid, { className: classes.backgroundContainerMessageBox, style: {
                            maxWidth: props.maxWidth ? props.maxWidth : 496
                        } },
                        react_1.default.createElement(core_1.Box, { className: classes.backgroundTopMessageBox },
                            react_1.default.createElement(core_1.Typography, { className: classes.textTitleMessageBox }, props.title ? props.title : null)),
                        react_1.default.createElement(core_1.Grid, { container: true, className: classes.contentMidContainerMessageBox, alignItems: "center" },
                            props.icon
                                ? react_1.default.createElement(core_1.Grid, { item: true, lg: 2, md: 2, sm: 2, xl: 2, xs: 2, className: classes.directionIcon }, typeIcon())
                                : null,
                            react_1.default.createElement(core_1.Grid, { item: true, lg: true, md: true, sm: true, xl: true, xs: true }, props.children
                                ? props.children
                                : props.contents
                                    ? renderContents()
                                    : react_1.default.createElement(core_1.Typography, { className: props.icon ? classes.paddingTypographyMessageBox : classes.paddingTypographyMessageBoxNoICon, style: { maxWidth: props.maxWidth ? props.maxWidth : 496 } }, props.message ? props.message : null)),
                            react_1.default.createElement(core_1.Grid, { container: true, className: classes.contentCommandContainerMessageBox }, commandOption())))))
            : react_1.default.createElement(core_1.Modal, { id: props.id, className: classes.dialog, open: props.valueDialog ? props.valueDialog : open, onClose: props.closeDialog ? props.closeDialog : closeDialog, closeAfterTransition: true, BackdropComponent: core_1.Backdrop, BackdropProps: { timeout: 500, classes: { root: typeBox() } } },
                react_1.default.createElement(core_1.Fade, { in: props.valueDialog ? props.valueDialog : open },
                    react_1.default.createElement(core_1.Grid, { className: classes.backgroundContainerDialog, style: {
                            maxWidth: props.maxWidth ? props.maxWidth : 496
                        } },
                        react_1.default.createElement(core_1.Grid, { container: true, className: classes.backgroundTopDialog },
                            react_1.default.createElement(core_1.Typography, { className: classes.textTitleDialog }, props.title ? props.title : null),
                            react_1.default.createElement("i", { className: "ppi ppi-x", id: "closeIconMessageBox", onClick: props.closeDialog ? props.closeDialog : closeDialog })),
                        react_1.default.createElement(core_1.Grid
                        /* container */
                        , { 
                            /* container */
                            className: classes.contentMidContainerDialog }, props.children
                            ? props.children
                            : props.contents
                                ? renderContents()
                                : react_1.default.createElement(core_1.Typography, { className: props.icon ? classes.paddingTypographyDialogIcon : classes.paddingTypographyDialog }, props.message ? props.message : null)))));
    };
    return (react_1.default.createElement(core_1.Grid, null,
        props.valueDialog || props.closeDialog ? functionModal() : react_1.default.createElement(core_1.Button, { id: props.id + '_' + 'button_close', onClick: openDialog }, "Abrir"),
        props.valueDialog ? props.valueDialog : open ? functionModal() : react_1.default.createElement(react_1.default.Fragment, null)));
};
exports.PPDialog = PPDialog;
